import { LoadingWheel } from "@src/components/Utility/LoadingWheel";
export const HeaderButtonsLoading = () => {
  return (
    <div>
      <div className="header_button_container _display--inline-block _margin-right--1rem">
        <button
          disabled={true}
          onClick={(event) => {
            event?.preventDefault();
            event?.stopPropagation();
          }}
          type="button"
          className="header_button_icon disabled"
        >
          <span>
            <LoadingWheel height="1" />
          </span>
        </button>
      </div>
    </div>
  );
};
